<template>
    <div class=" flex justify-center items-center h-screen">
        <h1 class="text-gray-400 text-[2rem] grid"><fa icon="frown" class=" text-[10rem] m-auto" /> 404 Page Not Found!</h1>
    </div>
</template>